import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=666c8d97&lang=pug"
import script from "./user-profile.vue?vue&type=script&lang=ts"
export * from "./user-profile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports